import React, { type ReactElement } from 'react';

import classnames from 'classnames';

import { Icon, type IconName } from '../Icon';
import { Small, Text, type TypographyColor } from '../Typography';

import styles from './FormControlMessage.module.scss';

type FormControlMessageType = 'error' | 'alert' | 'helper';

type FormControlMessageProps = {
    className?: string;
    message?: string;
    type?: FormControlMessageType;
};

const ICONS: { [key in FormControlMessageType]?: IconName } = {
    error: 's-icon-circle-xmark',
    alert: 's-icon-triangle-exclamation'
};

const COLORS: { [key in FormControlMessageType]?: TypographyColor } = {
    error: 'danger',
    alert: 'alert',
    helper: 'secondary'
};

export const FormControlMessage = ({
    className,
    message,
    type = 'error',
    ...rest
}: FormControlMessageProps): ReactElement | null => {
    if (!message) {
        return null;
    }
    const icon = ICONS[type];
    const color = COLORS[type];

    return (
        <Text
            as="div"
            className={classnames(styles.container, className)}
            role="alert"
            color={color}
            {...rest}
        >
            {icon && <Icon size="medium" className={styles.icon} name={icon} />}
            <Small>{message}</Small>
        </Text>
    );
};
